__turbopack_context__.v({
  "indicator": "LiveNow-module__ee9b9a__indicator",
  "text": "LiveNow-module__ee9b9a__text",
});
